import { render, staticRenderFns } from "./IndustryType.vue?vue&type=template&id=514d2faf&"
import script from "./IndustryType.vue?vue&type=script&lang=js&"
export * from "./IndustryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports